import { ClienteCampoPersonalizadoSelecionado } from './cliente-campo-personalizado-selecionado';
import { ClienteCampoPersonalizado } from './cliente-campo-personalizado';
import { IntegradorFinanciadoraSimples } from './financiamento/integrador-financiadora-simples';
import { TipoPrecificacao } from './enum';

export class Cliente {
  id: number;
  nome: string;
  cep: string;
  ibge: string;
  rua: string;
  n: string;
  compl: string;
  bairro: string;
  cidade: string;
  uf: string;
  email: string;
  site: string;
  tel1: string;
  tel2: string;
  cel: string;
  cel2: string;
  obs: string;
  dtNasc: Date;
  cpf: string;
  rg: string;
  org: string;
  mae: string;
  pai: string;
  sexo: string;
  estCivil: string;
  nat: string;
  conj: string;
  cnpj: string;
  inscEst: string;
  tipo: number;
  dtAbert: Date;
  fantasia: string;
  contato: string;
  ativo: number;
  vendedor: number;
  nomeVendedor: string;
  cargoContato: string;
  integrarGI: boolean;
  tokenGI: string;
  descontoGI: number;
  descontoMaximoGI: number;
  codErp: string;
  segm?: number;
  descricaoSegm: string;
  descFrete: number;
  camposPersonalizados: ClienteCampoPersonalizadoSelecionado[];
  camposPersonalizadosMontar: ClienteCampoPersonalizado[];
  idCD?: number;
  apelido: string;
  marketPlace: boolean;
  daMP: number;
  valorDaMP: number;
  estoqueMP: number;
  tokenMP: string;
  hostMP: string;
  daKitMP: number;
  valorDaKitMP: number;
  podeReceberItensMP: boolean;
  podeReceberKitsMP: boolean;
  descontoManual: boolean;
  cnpjMatriz: string;
  daGI: number;
  acrescimoGI: number;
  integracaoSolaryum: boolean;
  daIS: number;
  valorDaIS: number;
  estoqueIS: number;
  tokenIS: string;
  hostIS: string;
  daKitIS: number;
  valorDaKitIS: number;
  podeReceberItensIS: boolean;
  podeReceberKitsIS: boolean;
  podeVerMenuRepasse: boolean;
  podeVerValorServico: boolean;
  podeAlterarGestao: boolean;
  salvar: boolean;
  TagsJson: string;
  tags: string;
  integracaoSub: boolean;
  daSub: number;
  valorDaSub: number;
  tokenSub: number;
  urlSub: number;
  dataAtualizacaoReceita: Date | null;
  fonteAtualizacaoReceita: string | null;
  rzkId: string;
  codSuframa: string;
  listaCnaes: string[] | null;
  optanteSimples: boolean | null;
  dataSituacaoSimples: Date | null;
  optanteSimei: boolean | null;
  dataSituacaoSimei: Date | null;
  tipoPrecificacao: TipoPrecificacao;
  valorPrecificacao: number;
  apiEstoque: boolean;
  tokenApiEstoque: string;

  // virtuais
  financiadoras?: IntegradorFinanciadoraSimples[];
}
